export const zeroFill = (num) => {
  return num.toString().padStart(4, '0');
}